import React, { useState } from 'react';
import classes from "./styles/program.module.css";
import workout from "../../assets/thirdSec/workout.png";
import checkIcon from "../../assets/thirdSec/check.png";
import { useNavigate } from 'react-router-dom';

const ProgramSection = () => {
  const [program , setProgram] = useState(true);
  const navigate = useNavigate();


  const scrollToContact = () => {
    const element = document.getElementById("DiscoveryCallSection");
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

 const scrollToRightCon = () => {
  const element = document.getElementById(program ? "FitnessRightCon" : "NutritionRightCon");

  if (element) {
    const rect = element.getBoundingClientRect();
    const absoluteElementTop = rect.top + window.pageYOffset;

    // Check if it's mobile (can adjust threshold as needed)
    const isMobile = window.innerWidth <= 768;

    const offset = isMobile ? (program ? -465: -450) : -80;

    window.scrollTo({
      top: absoluteElementTop + offset,
      behavior: 'smooth'
    });
  }
};

 
  
  return (
    <div className={classes.color}>
    <div className={classes.container}>
      <div className={classes.innerCon}>

      <div className={classes.leftCon}>
        <img src={workout} alt="programs" />
        <h2>Programs</h2>
        <div className={classes.buttonCon}>
          <div className={classes.toggleBtnCon}>
            <button className={`${classes.lefttogle} ${program ? classes.toggleBtnActive : classes.toggleBtn}`} onClick={() => {setProgram(true); scrollToRightCon();}}>Fit & Nourish <br /><span>Live Online Sessions</span></button>
            <button className={`${classes.righttogle} ${!program ? classes.toggleBtnActive : classes.toggleBtn}`} onClick={() => {setProgram(false); scrollToRightCon();}}>Nourish You <br /><span>Nutrition Consultation</span></button>
          </div> 
          <button id='JoinNowBtn' className={`button ${classes.joinBtn} ${classes.Btn}`} onClick={() => navigate("/checkout")}>Join Now</button>
        </div>
        <h3>{program ? "Fit & Nourish Live Online Sessions" : "Nourish You Online Nutrition Consultation"}</h3>
        {program? <p>Get fit for what truly matters <br/>work, home, and life. Not just six-packs or calorie counts. This is fitness that fuels real transformation.</p> : <p>Because your life is busy.<br/> Your health still matters.</p>}
      </div>

      {program ? <div className={classes.rightCon} id='FitnessRightCon'>
        <div className={`${classes.div}`}>
                    <div className={classes.imgCon}><img src="https://cdn-icons-png.flaticon.com/128/4939/4939498.png" alt="" /> <h3>About the Program</h3></div>
                    <div className={classes.innerDiv}>
                      <p><img src={checkIcon} alt='check'/><b>Small group format</b> (Only 5 people per batch) for deep focus and support</p>
                      <p><img src={checkIcon} alt='check'/>Participant privacy is maintained. Live sessions via Zoom Focus Mode – <b>only the coach can see you</b></p>
                      <p><img src={checkIcon} alt='check'/><b>Alternate day sessions</b> for greater consistency </p>
                      <p><img src={checkIcon} alt='check'/><b>WhatsApp support</b> for motivation, reminders & quick check-ins</p>
                      <p><img src={checkIcon} alt='check'/>Monthly <b>nutrition guidance</b> tailored to your lifestyle</p>
                      <p><img src={checkIcon} alt='check'/><b>Progress tracking</b> built into your weekly flow</p>
                      <p><img src={checkIcon} alt='check'/>Gentle habit nudges to create real, <b>lasting change</b></p>
                      <p><img src={checkIcon} alt='check'/><b>Daily journaling</b> prompts to brain-dump, habit creation, and planning</p>
                    </div>
                  </div>
        
                  <div className={`${classes.div}`}>
                  <div className={classes.imgCon}><img src="https://cdn-icons-png.flaticon.com/128/4793/4793006.png" alt="" /><h3>Who Is It For?</h3></div>
                    <div className={classes.innerDiv}>
                      <p><img src={checkIcon} alt='check'/>If you want <b>real-life transformation</b>—not just weight loss or calorie tracking</p>
                      <p><img src={checkIcon} alt='check'/>If you want your health to <b>fuel your productivity</b> at work, home, and in your relationships</p>
                      <p><img src={checkIcon} alt='check'/>If you’re tired of unrealistic routines and want <b>fitness that fits your life</b>—this is for you</p>
                    </div>
                  </div>

                  <div className={`${classes.div}`}>
                  <div className={classes.imgCon}><img src="https://cdn-icons-png.flaticon.com/128/14228/14228361.png" alt="" /><h3>What benefit from working out with Me?</h3></div>
                    <div className={classes.innerDiv}>
                      <p><img src={checkIcon} alt='check'/>Boost your mood, reduce anxiety, and <b>feel more balanced</b></p>
                      <p><img src={checkIcon} alt='check'/>Sharpen your focus, <b>improve memory</b>, and think clearly</p>
                      <p><img src={checkIcon} alt='check'/><b>Sleep deeper</b> and start each day with real energy</p>
                      <p><img src={checkIcon} alt='check'/>Build confidence, <b>body positivity, and self-belief</b></p>
                      <p><img src={checkIcon} alt='check'/><b>Create discipline</b>, resilience, and a more productive lifestyle</p>
                      <p><img src={checkIcon} alt='check'/><b>Burn fat, lose weight, build lean muscle</b>, and increase stamina—sustainably</p>
                    </div>
                  </div>
        
                  <div className={`${classes.div}`}>
                  <div className={classes.imgCon}><img src="https://cdn-icons-png.flaticon.com/128/3043/3043888.png" alt="" /><h3>How the Sessions Work</h3></div>
                    <div className={classes.innerDiv}>
                      <p><img src={checkIcon} alt='check'/>Small pre-planned batches <b>(max 5 per group)</b></p>
                      <p><img src={checkIcon} alt='check'/>Zoom Focus Mode ensures privacy—<b>only the coach can see you</b></p>
                      <p><img src={checkIcon} alt='check'/><b>No awkwardness, no judgment</b>—just real coaching</p>
                      <p><img src={checkIcon} alt='check'/><b>Minimal equipment needed</b>—do it from your living room</p>
                    </div>
                  </div>
        
                  <div className={`${classes.div}`}>
                  <div className={classes.imgCon}><img src="https://cdn-icons-png.flaticon.com/128/1349/1349993.png" alt="" /><h3>How to Join</h3></div>
                    <div className={classes.innerDiv}>
                      <p><img src={checkIcon} alt='check'/>Click on <b style={{cursor: "pointer"}} onClick={() => navigate("/checkout")}>Join Now</b> and complete the formalities</p>
                      <p><img src={checkIcon} alt='check'/> <b>Select Your Preferred Time</b> while joining the program.</p>
                      <p>Three Sessions on (Mon, Wed, Fri) and Three on (Tue, Thu, Sat)</p>
                      <div className={classes.timingCon}>
                        <div>
                          <p><b>Morning Timings</b></p>
                          <p>6:00 – 6:40 AM</p>
                          <p>7:00 – 7:40 AM</p>
                          <p>8:00 – 8:40 AM</p>
                        </div>
                        {/* <div>
                          <p><b>Evening Slots</b></p>
                          <p>4:00 – 4:40 PM</p>
                          <p>5:00 – 5:40 PM</p>
                          <p>6:00 – 6:40 PM</p>
                        </div> */}
                      </div> 
                      <p>*Note this may change as per new batches and availability.</p>
                      <p><img src={checkIcon} alt='check'/><b>A questionnaire will be shared with you</b> to understand your lifestyle and food preferences etc.</p>
                      <p><img src={checkIcon} alt='check'/>An onboarding <b>call will be scheduled with you within 48 hours to walk you through the process</b></p>
                    </div>
                  </div>

                  <div className={`${classes.div}`}>
                  <div className={classes.imgCon}><img src="https://cdn-icons-png.flaticon.com/128/4375/4375408.png" alt="" /><h3>Fees</h3></div>
                    <div className={classes.innerDiv}>
                      <p>Monthly: <del>₹15,000</del> <b><span>₹9,999</span> (limited offer)</b></p>
                      <p>Quarterly: <del>₹45,000</del> <b><span>₹24,000</span> (Save ₹21,000)</b></p>
                    </div>
                    <div className={classes.innerDiv}>
                      <button className={`button ${classes.ctaBtn} ${classes.Btn}`} onClick={scrollToContact}>Book a Free Discovery Call</button>
                    </div>
                  </div>
      </div>
      :
      <div className={classes.rightCon} id='NutritionRightCon'>
  <div className={`${classes.div}`}>
    <div className={classes.imgCon}>
      <img src="https://cdn-icons-png.flaticon.com/128/4939/4939498.png" alt="" />
      <h3>About the Program</h3>
    </div>
    <div className={classes.innerDiv}>
      <p><img src={checkIcon} alt='check'/><b>1-on-1 Nutrition Consultations:</b> Personalized advice based on your health goals & lifestyle</p>
      <p><img src={checkIcon} alt='check'/><b>Postpartum Nutrition Support:</b> Helps with recovery, and getting back stronger</p>
      <p><img src={checkIcon} alt='check'/><b>Meal Planning & Prep Guidance:</b>
        <ul>
          <li>	&nbsp;	&nbsp; • Time-saving meal plans & easy recipes</li>
          <li>	&nbsp;	&nbsp; • Based on your preferences—no crash diets</li>
        </ul>
      </p>
      <p><img src={checkIcon} alt='check'/><b>Health & Wellness:</b> Natural food-based strategies to manage stress, fatigue, mood swings</p>
      <p><img src={checkIcon} alt='check'/><b>Workplace Wellness Tips:</b> Smart snacking, mindful eating, and balanced workday meals</p>
      <p><img src={checkIcon} alt='check'/><b>WhatsApp support </b> for motivation, reminders & quick check-ins</p>
      <p><img src={checkIcon} alt='check'/>Monthly <b>nutrition guidance</b> tailored to your lifestyle</p>
      <p><img src={checkIcon} alt='check'/><b>Progress tracking</b> built into your weekly flow</p>
      <p><img src={checkIcon} alt='check'/>Gentle habit nudges to create real, <b>lasting change</b></p>
      <p><img src={checkIcon} alt='check'/><b>Daily journaling</b> prompts to brain-dump, create habits and planning </p>
    </div>
  </div>

  <div className={`${classes.div}`}>
    <div className={classes.imgCon}>
      <img src="https://cdn-icons-png.flaticon.com/128/4793/4793006.png" alt="" />
      <h3>Who Is This For?</h3>
    </div>
    <div className={classes.innerDiv}>
      <p><img src={checkIcon} alt='check'/>For those who <b>can’t find time to exercise or attend regular sessions</b></p>
      <p><img src={checkIcon} alt='check'/>For those <b>who travel extensively</b></p>
      <p><img src={checkIcon} alt='check'/><b>Too busy for fixed time</b> sessions </p>
      <p><img src={checkIcon} alt='check'/>Don’t enjoy or <b>can’t commit to exercise</b> right now</p>
      <p><img src={checkIcon} alt='check'/><b>Juggling work</b>, home, or parenting</p>
      <p><img src={checkIcon} alt='check'/>New mothers <b>needing energy and recovery at their own pace</b></p>
      <p><img src={checkIcon} alt='check'/>Perfect for <b>working professionals, busy moms.</b></p>
      <p><img src={checkIcon} alt='check'/>Anyone ready to <b>eat better & feel better</b>—without fad diets</p>
    </div>
  </div>

   <div className={`${classes.div}`}>
                  <div className={classes.imgCon}><img src="https://cdn-icons-png.flaticon.com/128/14228/14228361.png" alt="" /><h3>Benefits that you will see</h3></div>
                    <div className={classes.innerDiv}>
                      <p><img src={checkIcon} alt='check'/>Boost your mood, reduce anxiety, and <b>feel more balanced</b></p>
                      <p><img src={checkIcon} alt='check'/>Sharpen your focus, <b>improve memory</b>, and think clearly</p>
                      <p><img src={checkIcon} alt='check'/><b>Sleep deeper</b> and start each day with real energy</p>
                      <p><img src={checkIcon} alt='check'/>Build confidence, <b>body positivity, and self-belief</b></p>
                      <p><img src={checkIcon} alt='check'/><b>Create discipline</b>, resilience, and a more productive lifestyle</p>
                      <p><img src={checkIcon} alt='check'/><b>Burn fat, lose weight, build lean muscle</b>, and increase stamina—sustainably</p>
                    </div>
    </div>

  <div className={`${classes.div}`}>
    <div className={classes.imgCon}>
      <img src="https://cdn-icons-png.flaticon.com/128/3043/3043888.png" alt="" />
      <h3>How to Join</h3>
    </div>
    <div className={classes.innerDiv}>
      <p><img src={checkIcon} alt='check'/>Click on <b style={{cursor: "pointer"}} onClick={() => navigate("/checkout")}>Join Now</b> and complete the formalities</p>
      <p><img src={checkIcon} alt='check'/>A questionnaire will be shared with you <b>to understand your lifestyle</b> and food preferences etc</p>
      <p><img src={checkIcon} alt='check'/>An onboarding <b>call will be scheduled with you within 48 hours to walk you through the process</b></p>
    </div>
  </div>

  <div className={`${classes.div}`}>
                  <div className={classes.imgCon}><img src="https://cdn-icons-png.flaticon.com/128/4375/4375408.png" alt="" /><h3>Fees</h3></div>
                    <div className={classes.innerDiv}>
                      <p>Monthly: <del>₹9,999</del> <b><span>₹4,999</span> (limited offer)</b></p>
                      <p>Quarterly: <del>₹15,000</del> <b><span>₹9,999</span> (Save ₹20,000)</b></p>
                    </div>
                    <div className={classes.innerDiv}>
                      <button className={`button ${classes.ctaBtn} ${classes.Btn}`} onClick={scrollToContact}>Book a Free Discovery Call</button>
                    </div>
                  </div>
</div>
}
      </div>
    </div>
    </div>
  )
}

export default ProgramSection
